import { Injectable } from '@angular/core';
import { Http, Response , Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Config } from '../../../config/config';

@Injectable()
export class ThongBaoService {    
    constructor(private http: Http) { }
    ds_thongbao(trangthai) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            TrangThai:trangthai
        };        
        return this.http.post(Config.apiUrl + 'ThongBao/ds_thongbao', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    } 
    ds_nhanviencoquan(idnhomcq, idcoquan, admin) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            IdNhomCQ:idnhomcq,
            IdCoQuan:idcoquan,
            Admin:admin
        };        
        return this.http.post(Config.apiUrl + 'ThongBao/nhomcoquan_nhanvien', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    } 
    ds_nhomnhanvien(id) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            Id:id
        };        
        return this.http.post(Config.apiUrl + 'ThongBao/ds_nhomnhanvien', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    } 
    ct_thongbao(id) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            Id:id
        };        
        return this.http.post(Config.apiUrl + 'ThongBao/ct_thongbao', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }  
    luu_thongbao(TT) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = TT;        
        return this.http.post(Config.apiUrl + 'ThongBao/luu_thongbao', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    huy_thongbao(id) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = {
            Id:id
        };        
        return this.http.post(Config.apiUrl + 'ThongBao/huy_thongbao', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    kichhoat_thongbao(TT) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));
        let data = TT;        
        return this.http.post(Config.apiUrl + 'ThongBao/kichhoat_thongbao', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
    luu_taonhom(data) {
        let headers = new Headers();
        headers.append("Content-Type", "application/json;charset=utf-8");
        headers.append('Authorization', 'Bearer ' + localStorage.getItem("scnntttoken"));        
        return this.http.post(Config.apiUrl + 'ThongBao/luu_taonhom', JSON.stringify(data), { headers: headers }).map(resp => resp.json());
    }
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/he-thong/thong-bao/thong-bao.services.ts